The `Boolean` scalar type represents `true` or `false`.
